export default [
  {
    cart_not_found: "Beklager, vi kunne ikke finde din indkøbskurv...",
    error_alert_text: "¡Noget gik galt! Prøv igen.",
    error_alert_title: "Oops!",
    forbidden: "Forbudt",
    not_athorization_message_title: "Du har ikke autorisation...",
    not_found: "Ikke fundet",
    not_found_message_title: "Siden blev ikke fundet...",
    page_message_description:
      "Kontroller venligst, at den URL, du har indtastet, er korrekt, eller klik på knappen nedenfor for at vende tilbage.",
    warning_alert_title: "Opmærksomhed",
    session_exist:
      "Vi kan desværre ikke gennemføre din bestilling, din indkøbskurv skal nulstilles. Tryk på nulstil knappen for at prøve igen.",
    PAYMENT_TYPE_NOT_ALLOWED:
      "Den valgte betalings metode er ikke mulig hos denne butik. Prøv venligst med en anden betalings metode.",
    NOT_YOUR_PAYMENT_ACCOUNT:
      "Der skete en fejl. Kontakt venligst supporten hello@orderapp.dk",
    SELECTED_TIME_NOT_ALLOWED:
      "Det ønskede tidspunkt er desværre ikke mulig, vælg venligst en anden tid.",
    DELIVERY_PARTNER_DECLINED:
      "Kontakt venligst supporten på hello@orderapp.dk, Vi kunne ikke oprette en levering med de oplyste informationer.",
    MINIMUM_AMOUNT_NOT_REACHED:
      "Minimums bestilling er ikke opnået, kontakt supporten på hello@orderapp.dk hvis du ikke kan komme videre.",
    COMMON_ERROR: "Noget gik galt, kontakt supporten på hello@orderapp.dk",
    //
    ALREADY_EXIST:
      "Vi kunne ikke gennemfører din ordre, hvis der er trukket penge fra din konto, så kontakt venligst supporten på hello@orderapp.dk",
    NOT_VALIDATED_YET:
      "Kontakt venligst supporten på hello@orderapp.dk noget gik galt med validering.",
    DELIVERY_PARTNER_DECLINED_CHECKOUT:
      "Vi kunne ikke oprette leveringen, hvis der er trukket penge fra dit kort, så kontakt venligst supporten på hello@orderapp.dk",
    SAVE_ORDER_FAILED:
      "Vi kunne ikke gennemføre din ordre, hvis der er trukket penge fra dit kort, så kontakt supporten på hello@orderapp.dk",
    ERROR_SAVE_CARD:
      "Noget gik galt med {{code}} kontakt venligst supporten hello@orderapp.dk",
  },
];
